import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Collapse from "@mui/material/Collapse";
import { Context } from "../../../../_context/Store";
import { contextApiActions } from "../../../../_redux/_constants";
import PointBudgetApprovalRequestForm from "../forms/PointBudgetApprovalRequestForm";
import UiApprovalStatus from "../../../_uiComponents/common/UiApprovalStatus";
import PointBudgetApprovalRequestSummary from "./PointBudgetApprovalRequestSummary";

export default function PointBudgetApproval(props) {

    const [state, dispatch] = useContext(Context);
    const [open, setOpen] = React.useState(false);
    const [active, setActive] = React.useState();

    const manageOpen = (clickedIndex) => {
        if (active === clickedIndex) {
            setActive(null);
            setOpen(true);
        } else {
            setActive(clickedIndex);
            setOpen(true);

        }
    };

    const rowValueList = [
        {
            id: 0,
            requested_by: 'Test',
            requested_on: 'league individual',
            approval_status: 'Pending',
            requested_points: '100'
        },
        {
            id: 1,
            requested_by: 'Test',
            requested_on: 'league individual',
            approval_status: 'Approved',
            requested_points: '100'
        },
        {
            id: 2,
            requested_by: 'Test',
            requested_on: 'league individual',
            approval_status: 'Rejected',
            requested_points: '100'
        },

    ]


    const raisePointBudgetApprovalRequest = () => {
        dispatch({
            type: contextApiActions.UI_MODAL_TOGGEL,
            payload: {
                show: true,
                heading: "Point Budget Approval Request",
                children: (
                    <PointBudgetApprovalRequestForm />

                ),
            },
        });
    };

    return (
        <>
            <Box sx={{ margin: 1 }}>
                <div className="sba-subtable-top-btns sb-incentive-sub-table">
                    <div className="sba-add-row-button">
                        <Button
                            variant="contained"
                            sx={{ mb: 1 }}
                            onClick={raisePointBudgetApprovalRequest}
                        >
                            Raise point budget approval request
                        </Button>
                    </div>

                </div>

                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <TableContainer sx={rowValueList.length > 5 ? { maxHeight: 500 } : ''}>
                        <Table stickyHeader size="small" aria-label="purchases">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Requested By</TableCell>
                                    <TableCell align="center">Requested On</TableCell>
                                    <TableCell align="center">Requested Points</TableCell>
                                    <TableCell align="center">Approval Status</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {rowValueList.map((row, index) => {

                                    return (
                                        <>
                                            <TableRow>
                                                <TableCell >{row.requested_by}</TableCell>
                                                <TableCell align="center">{row.requested_on}</TableCell>
                                                <TableCell align="center">{row.requested_points}</TableCell>
                                                <TableCell align="center"><UiApprovalStatus status={row.approval_status} /></TableCell>
                                                <TableCell align="center">
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        endIcon={
                                                            active == index &&
                                                                open ? (
                                                                <KeyboardArrowUpIcon />
                                                            ) : (
                                                                <KeyboardArrowDownIcon />
                                                            )
                                                        }
                                                        onClick={() => {
                                                            manageOpen(
                                                                index,
                                                                row.id,
                                                            );
                                                        }}
                                                    >
                                                        View Request Summary
                                                    </Button>
                                                </TableCell>


                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    style={{
                                                        paddingBottom: 0,
                                                        paddingTop: 0,
                                                        border: "none",
                                                        background: "rgb(250 250 250)",
                                                        borderBottom: "none",
                                                        whiteSpace: 'normal'
                                                    }}
                                                    colSpan={12}
                                                >
                                                    <Collapse
                                                        in={
                                                            active == index &&
                                                            open
                                                        }
                                                        timeout="auto"
                                                        unmountOnExit
                                                    >
                                                        {active == index &&
                                                            open && (
                                                                <PointBudgetApprovalRequestSummary />
                                                            )}
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Box>

        </>
    )
}
